import { useState } from "react";
import { Swiper as SwiperType } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { CarSlider, CarSliderNav } from "../../../data/demo/CarDemo1";
import { dynamicImage, dynamicNumber, Image } from "../../../utils";
import { Href } from "../../../constants";
import { Link } from "react-router-dom";

const CarImageSlider = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperType | null>(null);

  return (
    <div className="home-img-slider">
      <Swiper className="car-slider-main" {...CarSlider} thumbs={{ swiper: thumbsSwiper }}>
        {dynamicNumber(5).map((item, index) => (
          <SwiperSlide key={index}>
            <div className="main-car-img">
              <Image src={dynamicImage(`car/home-img/${item}.png`)} className="img-fluid w-100" />
              <div className="car-img-overlay" />
              <div className="car-banner">
                <h2 className="car-banner__title">Sell & Buy Your Car</h2>
                <h3 className="car-banner__subtitle">For the Best Price</h3>

                <div className="car-banner__stats">
                  <div className="stat">
                    <span className="stat__number">126+</span>
                    <span className="stat__label">Inventory</span>
                  </div>
                  <div className="divider" />
                  <div className="stat">
                    <span className="stat__number">1583+</span>
                    <span className="stat__label">Customers</span>
                  </div>
                </div>

                <div className="car-banner__buttons">
                  <Link to={'sell-your-car'}>
                    <button className="btn btn--light">Sell your car</button>
                  </Link>
                  <Link to={'inventory'}>
                    <button className="btn btn--primary">Get your new car</button>
                  </Link>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      {/* <Swiper className="absolute car-slider" {...CarSliderNav} onSwiper={setThumbsSwiper}>
        {dynamicNumber(3).map((item, index) => (
          <SwiperSlide key={index}>
            <a href={Href}>
              <Image src={dynamicImage(`car/home-img/${item}.png`)} className="img-fluid" />
            </a>
          </SwiperSlide>
        ))}
      </Swiper> */}
    </div>
  );
};

export default CarImageSlider;
